// FormComponents.js
import React, { useEffect, useRef, useState } from "react";
import "../assets/css/select2.min.css";
import $ from "jquery";
import "select2";
import { Link } from "react-router-dom";

// InputBox Component
const InputBox = ({
  label,
  fieldname,
  placeholder,
  value,
  onChange,
  type = "text",
  required = false,
  jsScript = "",
  disabled = false,
}) => (
  <div className="form-group">
    <label className="control-label">{label}</label>
    <input
      type={type}
      name={fieldname}
      id={fieldname}
      placeholder={placeholder}
      className="form-control"
      value={value || ""}
      onChange={onChange}
      required={required}
      disabled={disabled}
      {...(jsScript ? { ...jsScript } : {})}
    />
  </div>
);

// TextAreaBox Component
const TextAreaBox = ({
  label,
  fieldname,
  placeholder,
  value,
  onChange,
  required = false,
  jsScript = "",
}) => (
  <fieldset className="form-group">
    <label className="form-label semibold">{label}</label>
    <textarea
      name={fieldname}
      id={fieldname}
      placeholder={placeholder}
      className="form-control"
      value={value}
      onChange={onChange}
      required={required}
      {...(jsScript ? { ...jsScript } : {})}
    ></textarea>
  </fieldset>
);

// DropdownBox Component

const DropdownBox = ({
  label,
  fieldname,
  options,
  value,
  onChange,
  jsScript = "",
  disabled = false,
}) => {
  const selectRef = useRef(null);

  // Initialize Select2 on mount and clean up on unmount
  useEffect(() => {
    $(selectRef.current).select2({
      placeholder: "--Select--",
      allowClear: true,
    });

    // Cleanup the Select2 instance on unmount
    return () => {
      $(selectRef.current).select2("destroy");
    };
  }, []);

  // Force Select2 to update when value changes
  useEffect(() => {
    if (selectRef.current) {
      $(selectRef.current).val(value).trigger("change");
    }
  }, [value]);

  // Handle the select change and update the parent component's state
  const handleSelectChange = (event) => {
    // Get the selected value (which is the _id in your case)
    const selectedValue = event.target.value;

    // Trigger the parent onChange handler with the selected value (_id)
    onChange({ target: { name: fieldname, value: selectedValue } });
  };

  return (
    <div className="form-group p-1">
      <label className="control-label">{label}</label>
      <select
        ref={selectRef}
        name={fieldname}
        id={fieldname}
        className="select2 form-control"
        onChange={handleSelectChange} // Update value when the selection changes
        value={value} // Ensure the selected value is controlled via React state
        {...(jsScript ? { ...jsScript } : {})}
        disabled={disabled}
      >
        <option value="">--Select--</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

// CheckBox Component
const CheckBox = ({ label, fieldname, checked, onChange, id }) => (
  <div className="form-group">
    <label style={{ padding: "5px 10px" }}>{label}</label>
    <div className="input-group">
      <div className="switcher">
        <input
          type="checkbox"
          name={fieldname}
          id={`${fieldname}_${id}`} // Append the subService ID to make it unique
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={`${fieldname}_${id}`}></label>{" "}
        {/* Unique for each checkbox */}
      </div>
    </div>
  </div>
);

// DatePicker Component
const DatePicker = ({ label, fieldname, value, onChange, disabled = false }) => (
  <div className="form-group">
    <label className="control-label">{label}</label>
    <input
      type="date"
      className="form-control"
      id={fieldname}
      name={fieldname}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);
const UploadBox = ({ label, fieldname, onChange, onFileChange, placeholder, accept }) => {
  return (
    <div className="form-group">
      <label className="control-label" htmlFor={fieldname}>
        {label}
      </label>
      <input
        type="file"
        className="form-control"
        id={fieldname}
        name={fieldname}
        placeholder={placeholder}
        onChange={(e) => {
          if (onChange) onChange(e);
          if (onFileChange) {
            const file = e.target.files?.[0] || null;
            onFileChange(file, fieldname);
          }
        }}
        accept={accept}
      />
    </div>
  );
};
const SubmitButton = ({ pageBack, handleSubmit, disabled = false, loading = false }) => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <div style={{ float: "left", marginTop: "15px" }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={disabled || loading}
          >
            {loading ? (
              <>
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </button>
        </div>
        <div style={{ float: "left", marginTop: "15px", paddingLeft: "10px" }}>
          <Link to={pageBack} className="btn btn-danger">
            Cancel
          </Link>
        </div>
      </div>
    </div>
  );
};

const CustomDropdown = ({
  label,
  fieldname,
  options,
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="form-group p-1">
      <label className="control-label">{label}</label>
      <select
        name={fieldname}
        value={value}
        onChange={(e) => onChange(e)} // works with your existing handleChange
        className="form-control"
        disabled={disabled}
      >
        <option value="">--Select--</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};


// Export all components
export {
  InputBox,
  TextAreaBox,
  DropdownBox,
  CheckBox,
  DatePicker,
  UploadBox,
  SubmitButton,
  CustomDropdown,
};
